// import { useState, useEffect } from "react";
// import { Stack, Typography } from "@mui/material";

// export default function PHDateTime() {

//     const [now, setNow] = useState(new Date());

//     useEffect(() => {
//         const timer = setInterval(() => setNow(new Date()), 1000);
//         return () => clearInterval(timer);
//     }, []);

//     const date = now.toLocaleDateString("en-PH", {
//         timeZone: "Asia/Manila",
//         weekday: "long",
//         year: "numeric",
//         month: "long",
//         day: "numeric",
//     });

//     const time = now.toLocaleTimeString("en-PH", {
//         timeZone: "Asia/Manila",
//         hour: "2-digit",
//         minute: "2-digit",
//         second: "2-digit",
//         hour12: true,
//     });

//     return (
//         <Stack direction="column">
//             <Typography
//                 sx={{
//                     fontSize: 14,
//                     fontWeight: 600,
//                     color: "#ffffff",
//                     fontFamily: "monospace",
//                     letterSpacing: 0.3,
//                 }}
//             >
//                 {date}
//             </Typography>
//             <Typography
//                 sx={{
//                     fontSize: 14,
//                     fontWeight: 500,
//                     color: "#ffffff",
//                     fontFamily: "monospace",
//                     letterSpacing: 0.3,
//                 }}
//             >
//                 {time}
//             </Typography>
//         </Stack>

//     );
// }






import { useEffect, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const PHDateCard = () => {
    const [now, setNow] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setNow(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const getPhilippinesDate = () => {
        return new Intl.DateTimeFormat("en-PH", {
            timeZone: "Asia/Manila",
            weekday: "long",
            day: "2-digit",
            month: "long",
            year: "numeric",
        }).format(now);
    };

    const getPhilippinesTime = () => {
        return new Intl.DateTimeFormat("en-PH", {
            timeZone: "Asia/Manila",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true,
        }).format(now);
    };

    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: 280
            }}
        >
            {/* DATE */}
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="right"
                spacing={1}
            >
                <CalendarMonthIcon
                    sx={{
                        fontSize: 18,
                        color: "#e3f2fd",
                    }}
                />

                <Typography
                    sx={{
                        color: "#ffffff",
                        fontSize: "14px",
                        fontWeight: 600,
                        letterSpacing: 0.2,
                    }}
                >
                    {getPhilippinesDate()}
                </Typography>
            </Stack>

            {/* TIME */}
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="right"
                spacing={1}
                sx={{ mt: 1, }}
            >
                <AccessTimeIcon
                    sx={{
                        fontSize: 18,
                        color: "#e3f2fd",
                    }}
                />

                <Typography
                    sx={{
                        color: "#ffffff",
                        fontSize: "18px",
                        fontWeight: 600,
                        letterSpacing: 1,
                        lineHeight: 1,
                    }}
                >
                    {getPhilippinesTime()}
                </Typography>
            </Stack>
        </Box>
    );
};

export default PHDateCard;